export default __webpack_public_path__ + "static/media/vivabonito13.9343be69.jpg";